<template lang="pug">
div
  v-menu(v-model="show" rounded="lg" :close-on-content-click="false" :attach="attach" :offset-y="attach" :max-height="menuHeight" max-width="min-content")
    template(#activator="{ on, attrs }")
      v-sheet.text-md.round-xl.border-menu(v-bind="attrs" v-on="on" flat outlined :height="dense ? '40' : '48'" min-width="200")
        .d-flex.align-center.fill-height.px-4
          .text-sm.flex-grow-1.text-left.ellipsis-text(v-if="value") {{ getItemName(value) }}
          .text-sm.flex-grow-1.text-left(v-else-if="nullValueText") {{ nullValueText }}
          .text-sm.flex-grow-1.neutral500--text.text-left(v-else) {{ placeholder }}
          v-icon(size="24") $yzi-chevron-down
    .text-xs.white
      .search-input
        v-text-field.mb-2.mx-4.text-sm.round-xl(v-model="searchItem" outlined placeholder="Search item" dense hide-details autofocus)
        v-divider
      div(v-for="item in filteredItems")
        div.d-flex.align-center.px-4.py-3(v-if="isItemDisabled(item)" style="background-color: var(--v-neutral300)")
          div.text-sm.flex-grow-1.neutral700--text {{ item.name }}
        div.d-flex.align-center.px-4.py-3.clickable.hover-bg(v-else @click="selectItem(item)")
          div.text-sm.flex-grow-1.neutral700--text {{ item.name }}
        v-divider
      template(v-if="!filteredItems.length")
        .px-4.py-3 No results match

</template>

<script>
export default {
  props: {
    value: {
      default: null,
      required: true
    },
    items: {
      type: Array,
      default: (() => [])
    },
    placeholder: {
      type: String,
      default: null
    },
    attach: {
      type: Boolean,
      default: false
    },
    menuHeight: {
      type: String,
      default: '330'
    },
    nullValueText: {
      type: String,
      default: null
    },
    dense: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    show: false,
    searchItem: null,
  }),
  computed: {
    filteredItems() {
      if (this.searchItem) {
        const keyword = this.searchItem.toLowerCase()
        return this.items.filter(item => (item.name.toLowerCase().includes(keyword)))
      }
      return this.items
    },
  },
  methods: {
    getItemName (id) {
      let text = ''
      const panel = this.items.find(f => f.id === id)
      if (panel) {
        text = panel.name
      }
      return text
    },
    selectItem (item) {
      this.$emit('input', item.id)
      this.show = false
      this.searchItem = ''
    },
    isItemDisabled(item) {
      return this.value === item.id
    },
  }
}
</script>

<style scoped>
.border-menu {
  border: 1px solid var(--v-basic500);
  box-shadow: none;
}
.search-input {
  position: sticky;
  top: 0px;
  background-color: #FFFFFF !important;
  border-color: #FFFFFF !important;
  z-index: 4;
  padding-top: 8px;
}
.ellipsis-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>